import { useState, useEffect } from "react";
import ApiClient from "../../methods/api/apiClient";
import loader from "../../methods/loader";
import methodModel from "../../methods/methods";
import { Link, useNavigate, useParams } from "react-router-dom";
import Layout from "../../components/global/layout";
import { Tooltip } from "antd";
import FormControl from "../../components/common/FormControl";
import { toast } from "react-toastify";
import Select from "react-select";

const AddEditDiscount = () => {
  const { id } = useParams()
  const [form, setform] = useState({
    name: "",
    discount_type: null,
    amount_value: "",
    no_of_time_applied: "",
    no_of_time_applied_per_day: "",
    // max_usage_per_day: "",
  })
  const history = useNavigate()

  const discount_type = [
    { value: "flat", label: "Flat" },
    { value: "percentage", label: "Percentage" },
  ]

  useEffect(() => {
    if (id) {
      getDiscountDetail()
    }
  }, [])

  const getDiscountDetail = () => {
    loader(true)
    ApiClient.get(`discount/detail?id=${id}`).then((res) => {
      if (res.success) {
        setform({
          name: res?.data?.name,
          discount_type: res?.data?.discount_type ? { value: res?.data?.discount_type, label: res?.data?.discount_type[0].toUpperCase() + res?.data?.discount_type.slice(1) } : null,
          amount_value: res?.data?.amount_value,
          no_of_time_applied: res?.data?.no_of_time_applied,
          no_of_time_applied_per_day: res?.data?.no_of_time_applied_per_day,
          // max_usage_per_day: res?.data?.max_usage_per_day,
        })
      }
      else {
        toast?.error(res?.message)
      }
      loader(false)
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    let method = "post"
    let url = "discount/add"
    let value = {
      ...form,
      discount_type: form?.discount_type?.value,
      id: id || "",
    }
    if (id) {
      method = "put"
      url = "discount/update"
    } else {
      delete value.id
    }
    loader(true)
    ApiClient.allApi(url, value, method).then((res) => {
      if (res.success) {
        history(`/discount`)
      }
      loader(false)
    })
  }

  const hanldeAmount = (e) => {
    if (form?.discount_type?.value == "percentage") {
      if (e <= 100) {
        setform({ ...form, amount_value: e })
      }
    } else {
      setform({ ...form, amount_value: e })
    }
  }

  return (
    <>
      <Layout>
        <form onSubmit={handleSubmit} autoComplete="one-time-code">
          <div className="pprofile1">
            <div className="flex items-center mb-8">
              <Tooltip placement="top" title="Back">
                <Link to={`/discount`} className="!px-4 py-2 flex items-center justify-center rounded-lg shadow-btn hover:bg-[#F3F2F5] border transition-all mr-3">
                  <i className="fa fa-angle-left text-lg"></i>
                </Link>
              </Tooltip>
              <div>
                <h3 className="text-lg lg:text-2xl font-semibold text-[#111827]">{id ? "Edit" : "Add"} Discount</h3>
              </div>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              <div className="mb-3">
                <FormControl
                  type="text"
                  name="name"
                  label="Name"
                  placeholder="Name"
                  value={form?.name}
                  onChange={(e) => setform({ ...form, name: e })}
                  required
                />
              </div>
              <div className="mb-3">
                <label>Discount Type <span className="text-red-600"> *</span></label>
                <Select
                  value={form?.discount_type}
                  onChange={e => setform({ ...form, discount_type: e, amount_value: '' })}
                  options={discount_type}
                  className="capitalize"
                  placeholder="Select Discount Type"
                  required
                />
              </div>
              <div className="mb-3">
                <label>Amount {form?.discount_type?.value == "percentage" ? "(%)" : form?.discount_type?.value == "flat" ? "(USD)" : null}<span className="text-red-600"> *</span></label>
                <input type="text" value={form?.amount_value} onChange={e => hanldeAmount(methodModel.isNumber(e))} maxLength={10} required autoComplete="one-time-code" placeholder={`Amount ${form?.discount_type?.value == "percentage" ? "(%)" : form?.discount_type?.value == "flat" ? "(USD)" : ""}`} className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" />
              </div>
              <div className="mb-3">
                <label>Per person count <span className="text-red-600"> *</span></label>
                <input type="text" value={form?.no_of_time_applied} onChange={e => setform({ ...form, no_of_time_applied: methodModel.isNumber(e) })} maxLength={10} required autoComplete="one-time-code" placeholder="Per Person Count" className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" />
              </div>
              <div className="mb-3">
                <label>Per day count <span className="text-red-600"> *</span></label>
                <input type="text" value={form?.no_of_time_applied_per_day} onChange={e => setform({ ...form, no_of_time_applied_per_day: methodModel.isNumber(e) })} maxLength={10} required autoComplete="one-time-code" placeholder="Per Day Count" className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" />
              </div>
              {/* <div className="mb-3">
                <label>How many persons can use per day <span className="text-red-600"> *</span></label>
                <input type="text" value={form?.max_usage_per_day} onChange={e => setform({ ...form, max_usage_per_day: methodModel.isNumber(e) })} maxLength={10} required autoComplete="one-time-code" placeholder="How Many Persons Can Use Per Day" className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" />
              </div> */}
            </div>
            <div className="text-right">
              <button type="submit" className="text-white bg-[#F58D18] bg-[#F58D18] focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2">
                {id ? "Update" : "Save"}
              </button>
            </div>
          </div>
        </form>
      </Layout>
    </>
  );
};

export default AddEditDiscount;
